module.exports = __webpack_public_path__ + "img/C06TechShieldBearerChampion_ua.6863287a.webp";